<script setup>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import {onMounted, ref, computed} from "vue";
//axios请求
import {inject} from 'vue'
import Blood from "@/assets/singlecell/Blood.png";
import Eyestalk from "@/assets/singlecell/Eyestalk.png";
import Gill from "@/assets/singlecell/Gill.png";
import Heart from "@/assets/singlecell/Heart.png";
import Hepatopancreas from "@/assets/singlecell/Hepatopancreas.png";
import Intestine from "@/assets/singlecell/Intestine.png";
import Total from "@/assets/singlecell/Total.png";
import {ArrowRight} from '@element-plus/icons-vue'


onMounted(() => {
});
</script>
<template>
  <div>
    <index-navbar/>
    <section class="relative w-full h-full py-40 min-h-screen">
      <div class="container mx-auto items-center flex flex-wrap">
        <div class="col-12 my-3">
          <el-breadcrumb :separator-icon="ArrowRight" style="font-size: 22px">
            <el-breadcrumb-item :to="{ path: '/' }"><i class="bi bi-house me-1"></i>Home</el-breadcrumb-item>
            <el-breadcrumb-item>Single Cell</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="col-12">
          <div class="py-3 border-t border-blueGray-200 text-center">
            <div class="flex flex-wrap justify-center">
              <div class="w-full lg:w-9/12 px-4">
                <p class="text-lg leading-relaxed text-blueGray-700">
                </p>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="col-md-6">-->
        <!--          <img :src="UMAP_celltype">-->
        <!--        </div>-->
        <!--        <div class="col-md-6">-->
        <!--          <img :src="edit_FeaturePlot">-->
        <!--        </div>-->
        <div class="col-12">
          <div class="row justify-content-start">
              <span class="text-blueGray-500 text-lg font-bold text-left" style="font-size:25px">
                Single Cell Cluster
               </span>
          </div>
          <table class="clean-table">
            <tbody>
            <tr>
              <td>
                <div class="cell-content">
                  <router-link
                      :to="{name:'singlecelldetail',query:{tissue:'Blood'}}">
                    <div class="cell-text">
                      Blood
                    </div>
                    <img :src="Blood" alt="Blood" class="cell-img"/>
                  </router-link>
                </div>
              </td>
              <td>
                <div class="cell-content">
                  <router-link
                      :to="{name:'singlecelldetail',query:{tissue:'Eyestalk'}}">
                    <div class="cell-text">
                      Eyestalk
                    </div>
                    <img :src="Eyestalk" alt="Eyestalk" class="cell-img"/></router-link>
                </div>
              </td>
              <td>
                <div class="cell-content">
                  <router-link
                      :to="{name:'singlecelldetail',query:{tissue:'Gill'}}">
                    <div class="cell-text">
                      Gill
                    </div>
                    <img :src=Gill alt="Gill" class="cell-img"/></router-link>
                </div>
              </td>
              <td>
                <div class="cell-content">
                  <router-link
                      :to="{name:'singlecelldetail',query:{tissue:'Heart'}}">
                    <div class="cell-text">
                      Heart
                    </div>
                    <img :src=Heart alt="Heart" class="cell-img"/></router-link>
                </div>
              </td>
              <td>
                <div class="cell-content">
                  <router-link
                      :to="{name:'singlecelldetail',query:{tissue:'Hepatopancreas'}}">
                    <div class="cell-text">Hepatopancreas</div>
                    <img :src=Hepatopancreas alt="Hepatopancreas" class="cell-img"/></router-link>
                </div>
              </td>
              <td>
                <div class="cell-content">
                  <router-link
                      :to="{name:'singlecelldetail',query:{tissue:'Intestine'}}">
                    <div class="cell-text">Intestine</div>
                    <img :src=Intestine alt="Intestine" class="cell-img"/></router-link>
                </div>
              </td>
              <td>
                <div class="cell-content">
                  <router-link
                      :to="{name:'singlecelldetail',query:{tissue:'Total'}}">
                    <div class="cell-text">Total</div>
                    <img :src=Total alt="Total" class="cell-img"/></router-link>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>


      </div>

    </section>

    <footer-component/>
  </div>
</template>
<style scoped>
.clean-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  background: transparent;
}

.clean-table td {
  text-align: center;
  vertical-align: middle;
  padding: 15px;
  border: none;
}

.cell-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.cell-text {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 10px;
}

.cell-img {
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

/* ✅ 响应式布局 */
@media (max-width: 1200px) {
  .clean-table td {
    width: 33.3%; /* 平板屏幕显示3列 */
  }
}

@media (max-width: 768px) {
  .clean-table td {
    width: 50%; /* 手机屏幕显示2列 */
    padding: 15px;
  }

  .cell-img {
    width: 150px;
  }

  .cell-text {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .cell-img {
    width: 130px;
  }

  .cell-text {
    font-size: 14px;
  }
}


</style>